import React from 'react'
import PropTypes from 'prop-types'

const StarRating = ({ percentRating }) => {
	const rating = `${parseInt(percentRating || 0)}%`

	return (
		<span>
			<div className="mdi stars-outer">
				<div className="mdi stars-inner" style={{width: rating}} />
			</div>
		</span>
	)
}

StarRating.propTypes = {
	percentRating: PropTypes.number
}

export default StarRating
